/**
 * Adds a flag on the event so that handleContainerFocus()
 * can determine whether this event originated from this
 * component
 */
export var addFlagOnEventHandler = function (id) { return function (event) {
    // @ts-ignore
    // eslint-disable-next-line no-param-reassign
    event.nativeEvent.__eventFromFFESearchableDropdownId = id;
}; };
